import React from "react";
import { useStylesGeneral } from '../../styles/StyleComponents';
import Divider from '@material-ui/core/Divider';
import AccordionCS from '../../common/ComponentesCS/AccordionCS';
import DownloadLinkCS from '../../common/ComponentesCS/DownloadLinkCS';
import AlertCS from '../../common/ComponentesCS/AlertCS';
import AlertTitleCS from '../../common/ComponentesCS/AlertTitleCS';
import CardMedia from '../../common/ComponentesCS/CardMediaCS';
import ChecksCS from '../../common/ComponentesCS/ChecksCS';
import RadiosCS from '../../common/ComponentesCS/RadiosCS';
import ChipsCS from '../../common/ComponentesCS/ChipCS';
import ProgressBarCS from '../../common/ComponentesCS/ProgressbarCS';
import StepperCS from '../../common/ComponentesCS/StepperCS';
import "../../styles/site.css";

function Otros() {
    const classes = useStylesGeneral();
    const [msg, setMsg] = React.useState({ typealert: "info", msgalert: "No hay mensaje", open: true });

    const CloseAlert = () => setMsg({ typealert: "", msgalert: "", open: false });

    return (<>
        <label className='tituloSeccion'>Controles varios</label>
        <div className={classes.root}>
            <div className="fontNewsGothic">
                <AccordionCS > {<>{"Elemento React"}</>} </AccordionCS>
                <Divider style={{ marginBottom: 35, marginTop: 35 }} />
                <DownloadLinkCS label={'Ver Anexo'} tipo={"Archivo"} url={"https://csintercelulas.s3.amazonaws.com/common/media/csbanner.png"} Filename={"archivo.png"}></DownloadLinkCS>
                <Divider style={{ marginBottom: 35, marginTop: 35 }} />
                <AlertCS title={msg.typealert} msg={msg.msgalert} open={msg.open} CloseAlert={CloseAlert} />
                <Divider style={{ marginBottom: 35, marginTop: 35 }} />
                <AlertTitleCS />
                <Divider style={{ marginBottom: 35, marginTop: 35 }} />
                <ChecksCS></ChecksCS>
                <Divider style={{ marginBottom: 35, marginTop: 35 }} />
                <RadiosCS></RadiosCS>
                <Divider style={{ marginBottom: 35, marginTop: 35 }} />
                <ChipsCS></ChipsCS>
                <Divider style={{ marginBottom: 35, marginTop: 35 }} />
                <ProgressBarCS progress={20} buffer={100}></ProgressBarCS>
                <Divider style={{ marginBottom: 35, marginTop: 35 }} />
                <StepperCS></StepperCS>
                <Divider style={{ marginBottom: 35, marginTop: 35 }} />
                <CardMedia></CardMedia>
                <Divider style={{ marginBottom: 35, marginTop: 35 }} />
            </div>
        </div>
    </>)
}

export default React.memo(Otros);